"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Currency = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Currency = exports.Currency = /*#__PURE__*/function () {
  function Currency() {
    _classCallCheck(this, Currency);
  }
  return _createClass(Currency, null, [{
    key: "symbolForISO",
    value:
    /**
     * From the 3 letter ISO currency code, get the currency symbol, or empty string if not supported
     * @param {String} isoCode
     * @returns {String} currency symbol
     */
    function symbolForISO(isoCode) {
      switch (isoCode) {
        case "USD":
        case "CAD":
        case "AUD":
        case "NZD":
          return "$";
        case "EUR":
          return "€";
        case "GBP":
          return "£";
        case "JPY":
          return "¥";
        default:
          return "";
        //unhandled
      }
    }

    /**
     * Best method for rounding decimal currency, to the specified decimal place
     * @param {Number} num number to round
     * @param {Number} decimalPlaces number of places to round to, default = 2
     * @returns {String} the rounded number, as a string
     */
  }, {
    key: "round",
    value: function round(num) {
      var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      //best currency rounding: https://stackoverflow.com/a/48764436/8711782

      // If the number is smaller than the smallest decimal place return 0, to avoid issues with very small numbers in exp notation (which won't convert by adding another exponent)
      if (Math.abs(num) < "1e-" + decimalPlaces) {
        var zero = 0;
        return zero.toFixed(decimalPlaces);
      }
      num = Math.round(Math.abs(num) + "e" + decimalPlaces) * Math.sign(num);
      var rounded = Number(num + "e" + -decimalPlaces);
      return rounded.toFixed(decimalPlaces);
    }
  }]);
}();